// extracted by mini-css-extract-plugin
module.exports = {"button":"_3ibUTOiAfBtxXmd7mrB9X5","default":"DObpNLieB5G6JesJpk_Hk","primary":"_3yNOYa8pzp6Ni4ytYuFqNn"};